export const TRANSLATIONS_PT = {
    "select_language": "SELECIONAR IDIOMA",
    "location": "Localização",
    "business": "Negócio",
    "region": "Região",
    "filter_by": "Filtrar por",
    "menu": "Menu",
    "favourites": "Favoritos",
    "you_do_not_have_any_favourites": "Você não tem nenhum favorito.",
    "favourites_message": "As opções favoritas aparecerão como seleções padrão sempre que você visitar o Logistics MAESTRO. Para agradar o cliente basta clicar no ícone fav",
    "rows_per_page": "Linhas por página",
    "no_records_to_display": "Nenhum registro a ser exibido",
    "records": "Arquivo",
    "loading": "Carregamento",
    "location_search": "Pesquisa de Localização",
    "search": "Procurar",
    "locations": "Locais",
    "daily": "Diário",
    "weekly": "Semanalmente",
    "monthly": "Mensal",
    "quarterly": "Trimestral",
    "Jan": "Jan",
    "Feb": "Fev",
    "Mar": "Mar",
    "Apr": "Abr",
    "May": "Mai",
    "Jun": "Jun",
    "Jul": "Jul",
    "Aug": "Ago",
    "Sep": "Set",
    "Oct": "Out",
    "Nov": "Nov",
    "Dec": "Dez",
    "exportVolume": "Volume de Exportação",
    "importVolume": "Volume de importação",
    "exportOrder": "Detalhes do pedido de exportação",
    "importOrder": "Detalhes do pedido de importação",
    "lao_restricted": "A página que você está tentando acessar é restrita.\n Se você quiser solicitar um acesso, entre em contato com nosso suporte.",
    "lao_sites_failed": "Não conseguimos processar os dados relacionados ao LAO no momento.\n Tente atualizar a página depois de algum tempo. Se ainda assim não ajudar, entre em contato com nosso suporte.",
    "views_loading_failed": "Falha no carregamento de exibições",
    "feedback": "Realimentação",
    "feedback_sucessfully_posted": "Feedback postado com sucesso!",
    "something_went_wrong_please_try_again": "Algo deu errado!, por favor, tente novamente",
    "send_us_feedback": "Envie-nos comentários",
    "thank_you_for_taking_the_time_to_give_us_feedback": "Obrigado por tomar o tempo para nos dar feedback.",
    "are_you_satisfied_with_your_experience": "Você está satisfeito com sua experiência?",
    "required": "Necessário",
    "submit_feedback": "Enviar comentários",
    "tell_us_about_your_experience": "Conte-nos sobre sua experiência",
    "network": "Rede",
    "my_selections": "Minha Seleção",
    "clear_selections": "Limpar seleções",
    "save_selections": "Salvar seleções",
    "view_more": "Saiba Mais",
    "view_less": "Ver menos",
    "filters": "Filtros",
    "views": "Modos de exibição",
    "add_view": "Adicionar Vista",
    "reset": "Repor",
    "new_view": "Nova Vista",
    "save": "Salvar",
    "delete": "Excluir",
    "new_view_name_msg": "Cria um novo modo de exibição com configurações padrão",
    "enter_a_view_name": "Insira um nome de exibição",
    "saved_successfully": "salvo com êxito",
    "untitled_view": "Exibição sem título",
    "created": "Criado",
    "deleted": "deletado",
    "filter_search": "PESQUISA DE FILTROS",
    "clear_all": "Apagar tudo",
    "select_all": "Selecionar tudo",
    "enter": "Entrar",
    "expand": "Expandir",
    "collapse": "Colapso",
    "all": "Todo",
    "manage_columns": "Gerenciar colunas",
    "show_all": "Mostrar tudo",
    "hide_all": "Ocultar tudo",
    "refresh": "Atualizar",
    "export": "Exportação",
    "apply_selections": "Aplicar seleções",
    "more": "mais",
    "loading_text": "Sente-se e relaxe, enquanto recebemos os dados carregados para você...",
    "we_are_sorry": "Lamentamos...",
    "all_locations": "Todas as Unidades",
    "dot": "Locais Operados por Distribuição",
    "nondot": "Locais Operados Não Distribuidos",

    //LAO Table
    "purchase_order_origin": "PO",
    "order_#": "Order #",
    "order_type": "Tipo de pedido",
    "purchase_order_trade_PO": "PO FTZ#",
    "purchase_order_trade_SO": "SO FTZ/SO Virtual",
    "invoice_num": "Número da fatura",
    "invoicing_date": "Data de faturamento",
    "vendor_number": "Número do fornecedor",
    "vendor_plant": "Planta do Fornecedor",
    "origin_plant": "Planta (Planta de Origem)",
    "free_trade_destination_plant": "Código FTZ da planta",
    "free_trade_destination_description": "Nome da ZFM da fábrica",
    "ftz_invoice_number": "Número da fatura FTZ",
    "ftz_invoicing_date": "Data de faturamento da FTZ",
    "destination_plant": "Código do Cliente/Planta",
    "destination_description": "Nome do Cliente",
    "origin_port": "Porto de Origem",
    "international_shipper": "Expedidor Internacional",
    "booking_number": "Número da Reserva",
    "shipment_number": "Número de remessa de exportação",
    "load_number": "Número da Carga",
    "delivery_number": "Número de Entrega",
    "export_shipment_status": "Status da exportação",
    "origin_country": "País de Origem",
    "destination_country": "País de Destino",
    "bill_lading": "Conhecimento de embarque",
    "bid_lane_number": "Número da pista BID",
    "lao_order_details_search_helper_text": "Insira PO#, SO#, fatura#, Carga#, Entrega#.",
    "plant_ftz_code": "Código FTZ da planta",
    "vendor_name_plant": "Nome do Fornecedor/Planta (Orgin Plant)",
    "customer_code_plant": "Código do Cliente/Planta",
    "customer_name": "Nome do Cliente",
    "container_id": "ID do contêiner",
    "sku_id": "SKU (Material)",
    "material_description": "Descrição do Material",
    "material_type": "Tipo de material",
    "import_shipment_number": "Número de remessa de importação",
    "vendor_name": "Nome do fornecedor",
    "import_pre_shipment_status": "Status pré-embarque",
    "import_post_shipment_status": "Status Pós-Embarque",
    "import_destination_port": "Nome da porta de destino",
    "import_license_number": "Número de licença de importação",
    "import_license_date": "Data da licença de importação",
    "delivery_date": "Data de Entrega",
    "shipment_mode": "Modo de Envio",
    "import_container_type": "Tipo de contêiner",
    "incoterms": "Incoterms",
    "export_shipment_etd_date": "KC ETD",
    "export_shipment_eta_date": "KC ETA",
    "export_kc_documental_cutoff_date": "Corte Documental",
    "import_etd_date": "KC ETD",
    "import_eta_date": "KC ETA",
    "import_id_date": "Data de identificação",
    "import_declaration": "Declaração de Importação",
    "import_customs_channel": "Canal da Alfândega",
    "import_free_period_end_date": "Fim do Período Grátis",
    "import_kc_dock_time": "Tempo de doca KC",
    "import_req_date_cont_at_plant": "Data Req Cont na Fábrica",
    "import_time_of_arrival_in_plant": "Tempo De Chegada Na Fábrica",
    "import_date_cont_at_plant": "Data Cont Na Fábrica",
    "import_hour_cont_at_plant": "Hour Cont na Fábrica",
    "import_transhipment_etd": "Transbordo ETD",
    "import_tentative_eta": "Previsão de Chegada Provisória",
    "import_tentative_etd": "ETD provisório",
    "import_customs_leave": "Licença Aduaneira",
    "import_container_return_date": "Data de devolução do contêiner",
    "delivery_completion_ind": "Conclusão da entrega",
    "po_creation_date": "Data de criação do pedido de compra",
    "statistics_date": "Data das estatísticas",
    "dates_deviation": "Desvio de datas",
    "net_price": "Preço líquido",
    "currency": "Moeda",
    "need_number": "Número da necessidade",
    "tax_indicator": "Indicador de imposto",
    "confirmation_control_key": "Controle de confirmação",
    "requisitioner": "Requisitante",
    "virtual_plant_code": "Código de planta virtual",
    "virtual_plant_name": "Nome da planta virtual",

    "po_item": "PO Item",
    "sku_material": "SKU/Material",
    "po_quantity": "Quantidade PO",
    "quantity_packed": "Quantidade embalada",
    "volume_packed": "Volume Embalado",
    "order_unit": "Unidade de Pedidos",

    "no_data_found": "Nenhum dado encontrado",
    "download_started_msg": "O download do arquivo foi iniciado. Isso pode levar alguns segundos.",
    "download_progress_msg": "O download do arquivo já está em andamento",
    "export_view": "MODO DE EXIBIÇÃO DE EXPORTAÇÃO",
    "with_product_details": "COM DETALHES DO PRODUTO",
    "without_product_details": "SEM DETALHES DO PRODUTO",
    "with_managed_columns_and_filters_applied": "Com colunas e filtros gerenciados aplicados",
    "well_this_is_unexpected": "Bem, isso é inesperado...",
    "please_wait": "Aguarde...",
    "download_successful": "Download Sucesso!",
    "download_failed_msg": "Desculpa! Falha no download do arquivo. Tente novamente.",
    "view_deleted_success": "Exibir excluído com êxito",
    "view_deleted_failed": "Falha na exclusão de exibição",
    "view_fav_unfav_success": "Ver Sucesso Favorito/Não Favorito",
    "view_fav_unfav_failed": "Exibir Favorito/Não Favorito Falhou",
    "start_date": "Data de início",
    "end_date": "Data de término",
    "please_wait_while_the_data_is_loading": "Aguarde enquanto os dados estão carregando...",
    "view_created_updated_success": "Exibir criado/atualizado com êxito",
    "view_creation_updation_failed": "Falha na criação/updatation da exibição",
    "list_of_favourited_selections": "Lista de Seleções Favoritas",
    "business_unit": "Unidade de negócios",
    "delivery_eta": "Entrega ETA",
    "atleast_one_business_unit_needs_to_selected": "Pelo menos uma Unidade de Negócios precisa ser selecionada",
    "exportOrderMobile": "Exportação",
    "importOrderMobile": "Importação",
    "lao_order_details_search_helper_text_import": "PO#, Invoice#, BL#, Número de Remessa de Importação.",
    "yes": "Sim",
    "no": "Não",
    "po": "Ordem de compra",
    "sto": "Ordem de venda",
    "helperTextWithSeparator": "Para Pesquisa Múltipla, use apenas Ponto-e-vírgula como Separador. Ex: 111; 222 A pesquisa curinga(*) só está habilitada para Pesquisa Única. Ex: 111* ou 222*",
    "helperText": "Para pesquisa múltipla, use separadores como vírgula, espaço ou ponto-e-vírgula. Ex: 111.222 ou 111 222 ou 111; 222 A pesquisa curinga(*) só está habilitada para Pesquisa Única. Ex: 111* ou 222*",
    "dest_plant": "Planta de destino",
    "storage_location": "Local de armazenamento",
    "item_desc": "Item Desc",
    "pallets_qty": "Quantidade de paletes",
    "volume_qty": "Quantidade de volume",
    "availability_date": "Data de disponibilidade",
    "exportDRPDetails": "Exportar detalhes do DRP",
    "exportLoadPlanDetails": "Exportar detalhes do plano de carga",
    "priority": "Prioridade",
    "sku": "SKU",
    "volume_v3": "Volume (V3)",
    "description": "Descrição",
    "plant_origin": "Planta de origem",
    "quantity": "Quantidade",
    "fourkites_stage1": "FourKites Estágio 1",
    "fourkites_stage2": "FourKites Estágio 2",
    "fourkites_stage3": "FourKites Estágio 3",

    // LAO Hamburger
    "close_menu": "Fechar Menu",
    "home": "Casa",
    "export_planning": "Planejamento de exportação",
    "kpi": "KPI",

    // Export Planning - Chart
    "exportDRP": "Exportar DRP",
    "exportLoadPlan": "Plano de carga de exportação",
    "exportDRPMobile": "DRP",
    "exportLoadPlanMobile": "Plano de carga",
    "cases": "Casos",
    "volume": "Volume",
    "pallets": "Paletes",
    "containers": "Recipientes",

    // Export Planning - Table
    "cubication_id": "ID de cubação",
    "id_position": "Posição de identificação",
    "cubic_quantity": "Quantidade cúbica",
    "volume_m3": "Volume (m3)",
    "gross_weight": "Peso bruto",
    "total_value": "Valor total",
    "container": "Recipiente",
    "cnt_type": "Tipo CNT",
    "customer_code": "Código do cliente",
    "po_so_export": "Exportação de PO/SO",
    "po_so_ftz": "PO/SO FTZ",
    "shipping_line": "Linha de Navegação",
    "cutt_of_documental": "Cutt De Documental",
    "etd": "ETD",
    "eta": "ETA",
    "lane_number": "Número da pista",
    "invoice": "Fatura",
    "invoice_quantity": "Quantidade da fatura",
    "weight_unit": "Unidade de peso",
    "mode": "Modo",
    "load_date": "Data de carregamento",
    "carrier": "Portador",
    "comments": "Comentários",
    "delivery": "Entrega",
    "import_KPI": "KPI de importação",
    "export_KPI": "KPI de exportação",

    // Import KPI
    "forecast": "Previsão e Previsão de Contêineres",
    "po_line_items_by_shipment": "Itens de linha de pedido por remessa",
    "containers_ready_to_deliver": "Contêineres prontos para entrega",
    "po_items_ct_with_shipment": "Com expedição",
    "po_items_ct_without_shipment": "Sem Envio",
    "containers_with_import_declaration": "Contentores com Declaração de Importação",
    "containers_with_import_declaration_mobile": "Contêineres com ID",
    "containers_without_GR": "Contentores sem GR",
    "with_GR": "Com GR",
    "without_GR": "Sem GR",
    "without_GR_with_RDD": "Com data de solicitação",
    "without_GR_without_RDD": "Sem data de solicitação",
    "total": "Total",
    "containers_by_requested_delivery_date_at_plant": "Recipientes por data de entrega solicitada no centro",
    "total_shipments": "Total de remessas",
    "shipment_containers": "Contêineres de remessa",
    "total_containers": "Recipientes",
    "containers_without_import_declaration": "Contentores sem declaração de importação",
    "kpi_destination": "No destino",
    "pending_for_arrival": "Pendente de chegada",
    "with_import_declaration": "Com Declaração de Importação",
    "without_import_declaration": "Sem Declaração de Importação",
    "goods_received": "Mercadorias recebidas",
    "gr_date": "Data de GR",
    "plant_ftz": "Planta FTZ",
    "invoice_date": "Data da fatura",
    "international_declaration_date": "Data da Declaração Internacional",
    "carrier_operations": "Operações de Transportadora (top 10)",

    "po_items_by_deviation": "Itens de pedido por desvio",
    "po_item_with_deviation": "PO'S - item com desvio",
    "po_item_without_deviation": "PO'S - item sem desvio",
    "po_with_deviation": "%PO'S com desvio",

    "contract_percentage": "Porcentagem do contrato",
    "import_kpi_shipment": "Remessa",
    "import_kpi_container": "Recipiente",
    "bid": "Oferta",
    "spot": "Manchar",
    "live_status_text": "STATUS AO VIVO",
    "goods_completion": "Conclusão GR",
    "cntrWithGR": "Contêineres Recebidos",
    "cntrWithoutGR": "Contêineres de Importação",

    // Import KPI filter chips
    "searchSubType": "Tipo de busca",
    "import_kpi_po_items_shipment": "Itens Postais com Envio",
    "import_kpi_po_items_without_shipment": "Itens Postais sem Envio",

    "import_kpi_shipment_containers": "Contêineres de Embarque",
    "import_kpi_shipment_containers_id": "Contêineres de Embarque com Declaração de Importação",
    "import_kpi_shipment_containers_without_id": "Contêineres de Embarque sem Declaração de Importação",
    "import_kpi_shipment_containers_without_id_at_dest": "Contêineres de Embarque sem Declaração de Importação no Destino",
    "import_kpi_shipment_containers_without_id_pending": "Contêineres de Embarque Sem Declaração de Importação Pendentes de Chegada",

    "import_kpi_container_rtd_with_gr": "Contêineres com RG",
    "import_kpi_container_rtd_without_gr": "Contêineres sem RG",
    "import_kpi_container_rtd_with_gr_with_rd": "Contêineres com RG e com RDD",
    "import_kpi_container_rtd_without_gr_with_rd": "Contêineres sem RG e com RDD",
    "import_kpi_container_rtd_without_gr_without_rd": "Contêineres sem GR e sem RDD",

    "import_kpi_container_rdd": "Contêineres por Data de Entrega Solicitada na Fábrica",

    "import_kpi_po_items_deviation": "PO's com Desvio",
    "import_kpi_po_items_without_deviation": "Ordens de Procuração sem Desvio",
    "import_kpi_po_items_with_deviation": "%PO's com Desvio",

    "import_kpi_carrier_op_container_spot": "Spot de Contêineres de Operações de Porta-Aviões",
    "import_kpi_carrier_op_container_bid": "Oferta de Contêineres de Operações de Transportadores",
    "import_kpi_carrier_op_shipment_spot": "Operações de Transportadores Ponto de Remessa",
    "import_kpi_carrier_op_shipment_bid": "Licitação de Embarque de Operações de Transportadoras",

    "import_kpi_carrier_contract_container_spot": "Porcentagem de Contrato Spot de Contêineres",
    "import_kpi_carrier_contract_container_bid": "Porcentagem de Contrato para Oferta de Contêineres",
    "import_kpi_carrier_contract_shipment_spot": "Porcentagem de Contrato Spot de Remessas",
    "import_kpi_carrier_contract_shipment_bid": "Porcentagem de Contrato Oferta de Envio",

    "import_container_forecast": "Previsão de Contêineres de Importação",

    //Export KPI
    "export_line_items_planned": "Exportar partidas individuais planeadas",
    "po_items_with_ld_nbr": "Com número de carga",
    "po_items_without_ld_nbr": "Sem número de carga",
    "export_units_invoiced_by_last_6_months": "Unidades de exportação faturadas pelos últimos 6 meses",
    "export_units_by_carrier": "Unidades de exportação por transportadora",
    "export_units_by_status": "% de unidades de exportação por status",
    "total_count": "Contagem total",
    "export_units_by_shipment_mode": "Exportar unidades por modo de remessa",
    "ocean": "Oceano",
    "land": "Terra",
    "air": "Ar",
    "transport_by_shipment_mode": "% de transporte por modo de remessa",
    "export_units_containers_trucks": "Unidades de exportação (contêineres/caminhões)",
    "exports_unit": "Unidade de Exportação",
    "billing_pending": "Faturamento pendente",
    "export_line_items_with_load_number": "Exportar itens de linha com número de carga",
    "exports_unit_with_shipment": "Unidade de Exportação com Expedição",
    "exports_unit_invoiced": "Unidade de Exportação Faturada",
    "lds_invoiced_with_shipment": "Faturado com remessa",
    "lds_invoiced_without_shipment": "Faturado sem remessa",

    // Export KPI filter chips
    "export_kpi_line_items_with_ld": "Itens de linha com número de carga",
    "export_kpi_line_items_without_ld": "Itens de Linha sem Número de Carga",
    "export_kpi_export_units_total": "Total de Unidades de Exportação",
    "export_kpi_export_units_invoiced": "Unidades de Exportação Faturadas",
    "export_kpi_export_units_billing_pending": "Faturamento de Unidades de Exportação pendente",
    "export_kpi_units_with_shipment": "Unidades de Exportação com Envio",
    "export_kpi_units_without_shipment": "Unidades de Exportação sem Envio",
    "export_kpi_units_by_month": "Unidades de Exportação por Mês",
    "export_kpi_units_mode_ocean": "Unidades de Exportação por Modo de Embarque Oceano",
    "export_kpi_units_mode_land": "Unidades de Exportação por Modo de Embarque Terrestre",
    "export_kpi_units_mode_air": "Unidades de Exportação por Modo de Embarque Aéreo",
    "export_kpi_carrier": "Unidades de Exportação por Transportadora",
    "export_kpi_carrier_bid": "Unidades de Exportação por Proposta de Status de Transportadora",
    "export_kpi_carrier_spot": "Unidades de Exportação por Spot de Status de Transportadora",

    // Timeline KPI
    "timeline_KPI": "KPI da linha do tempo",
    "po_so_items": "Itens PO/SO",
    "shipments": "Transferências",
    "export_vendors": "Exportar fornecedores",
    "intercompany": "Intercompanhia",
    "direct_shipment": "Envio direto",
    "in_production_and_dispatch": "Em produção e expedição",
    "in_load_planning": "No planejamento de carga",
    "billed_and_charged": "Faturado e cobrado",
    "confirmed_itinerary": "Itinerário confirmado",
    "in_international_transit": "Em trânsito internacional",
    "in_customs_process_at_destination": "Em processo aduaneiro no destino",
    "nationalized_pending_placement_request": "Pedido de colocação pendente nacionalizado",
    "nationalized_with_placement_date": "Nacionalizado com data de colocação",
    "available": "Disponível",
    "qty": "Qty",
    "p%": "P%",

    // Leadtime KPI
    "leadtime_KPI": "KPI do Tempo de Entrega",
    "process_type": "Tipo de processo",
    "leadtime_shipment_etd_date": "KC ETD",
    "leadtime_shipment_eta_date": "KC ETA",
    "leadtime_shipment_id_date": "Data de identificação",
    "incoterm": "Incoterm",
    "lead_time_by_month_and_year": "Prazo de Entrega por Mês e Ano",
    "lead_time_by_origin_country": "Tempo de Entrega por País de Origem",
    "avg_international_transit_by_shipper": "Trânsito Internacional Médio por Expedidor",
    "international": "Internacional",
    "origin": "Origem",
    "destination": "Destino",
    "min": "Min",
    "max": "Max",
    "avg": "Média",
    "previous_dest": "Destino",
    "previous_international": "Internacional",
    "previous_origin": "Origem",
    "current_dest": "Destino",
    "current_international": "Internacional",
    "current_origin": "Origem",
    "previous": "Anterior",
    "current": "Atualidade",
    "intl": "Internacional",
    "org": "Org",
    "destMobile": "Dest",
    "tot": "Tot",
    "shipment_num": "Número da Remessa",
    "customer": "Cliente",
    "maritime_m": "Marítimo (M)",
    "external_vendor_ev": "Fornecedor Externo (EV)",
    "intercompany_ic": "Intercompanhia (IC)",
    "direct_shipment_ds": "Envio direto (DS)",
    "land_t": "Terra (T)",
    "air_a": "Ar (A)",

    // Chat bot
    "chatInitialMessage": "Oi! Como posso ajudá-lo?",
    "chatErrorMessage": "Tivemos um problema temporário e não conseguimos concluir seu pedido. Por favor, tente novamente em alguns minutos. Se o problema continuar, nos avise selecionando o botão para baixo abaixo.",
    "understanding_feasibility": "Entendendo a viabilidade",
    "extracting_contextual_intent": "Extração da intenção contextual",
    "generating_instructions": "Gerando instruções",
    "constructing_query_explanation": "Construção da explicação da consulta",
    "final_answer": "Gerando a resposta final",
    "processing": "Processamento",
    "chat_btn_text": "Conversa com a LISA",
    "bar": "Bar",
    "line": "Linha",
    "pie": "Torta",
    "combo": "Combo",
    "view_in_chart": "Visualização no Gráfico",
    "chat_message_intro": "Oi, eu sou LISA, sua companheira habilitada por IA no Maestro.",
    "chat_message_user_manual": "revisar o manual do usuário e assistir ao vídeo curto para aprender mais sobre como usar o LISA e fazer perguntas de forma eficaz.",
    "click_here": "Clique aqui",
    "lisa_auth_failed": "Parece que você não tem acesso ao LISA no momento.",
    "question": "Pergunta",
    "response": "Resposta",
    "ai_accuracy_disclaimer": "Resposta gerada por IA. Verifique a precisão.",
    "retrieval_details": "Detalhes da Recuperação",
    "how_i_understand_your_question": "Como entendi sua pergunta",
    "calculations": "Cálculos",
    "filters_applied": "Filtros aplicados",
    "please_write_feedback": "Por favor, escreva seu feedback.",
    "mention_what_didnt_go_right": "Mencione o que não saiu como esperado.",
    "optional": "Opcional",
    "submit": "Enviar",
    "remove": "Remover",
    "like": "Tipo",
    "unlike": "Diferente",
    "ai_request_cancelled": "Pedido cancelado",
    "stop": "Pare",
    "copy": "Cópia",
    "edit": "Edit",
    "resend": "Reenviar",
    "seconds": "Segundos",
    "your_download_will_begin_shortly": "Seu download começará em breve",
    "preview_to_lisa": "Prévia do LISA",
    "type_your_message": "Digite sua mensagem",
    "question_interpreted_as": "Pergunta interpretada como",
    "record": "Recorde",
    "export_without_chart": "Exportação sem Gráfico",
    "export_with_chart": "Exportação com Chart",
    "close_window": "Fechar a janela",

    // Alert Functionality
    "evaluate": "Avaliar",
    "save_alert": "Alerta de Salvamento",
    "add": "Adicionar",
    "another": "Outro",
    "select_a_filter": "Selecione um Filtro",
    "select_filters": "Selecionar Filtros",
    "you_can_only_select_00_or_30_in_minutes": "Você só pode selecionar 00 ou 30 em minutos",
    "every_15_mins": "A cada 15 minutos",
    "every_30_mins": "A cada 30 minutos",
    "every_1_hour": "A cada 1 hora",
    "custom": "Costume",
    "enter_alert_name": "Insira o Nome do Alerta",
    "update": "Atualização",
    "create_new": "Criar novo",
    "new_alert": "Novo Alerta",
    "create": "Criar",
    "alert": "Alerta",
    "create_new_alert": "Criar Novo Alerta",
    "alerts": "Alertas",
    "go_back_to_editing": "Volte para a edição",
    "criteria": "Critérios",
    "select_customer_or_sales_office": "Escritório Selecionado de Clientes/Vendas",
    "minutes": "Ata",
    "days": "Dias",
    "select_duration_unit": "Unidade de Duração Selecionada",
    "select_comparison_field": "Selecionar Campo de Comparação",
    "no_saved_alerts_found": "Nenhum alerta salvo foi encontrado!",
    "saved_alerts": "Alertas Salvos",
    "ct_saved_alerts": "CT - Alertas Salvos",
    "high": "Alto",
    "medium": "Médio",
    "low": "Baixo",
    "alert_saved_successfully": "Alerta salvo com sucesso",
    "please_validate_alert_and_try_again": "Por favor, valide o alerta e tente novamente!",
    "enter_valid_email_ids": "Insira IDs de e-mail válidos",
    "customers": "CLIENTES",
    "severity_of_alert": "Gravidade do alerta",
    "frequency_of_alert": "Frequência do alerta",
    "send_alerts_to": "Envie alertas para",
    "alert_created_by": "Alerta criado por",
    "send_alerts_when": "Envie Alertas quando",
    "select_field": "Área selecionada",
    "select_comparison": "Seleção de Comparação",
    "comparison": "Comparação",
    "comparison_with": "Comparação com",
    "additional_time": "Tempo Adicional"

}